import {
  FETCH_PATIENT_REQUEST,
  FETCH_PATIENT_SUCCESS,
  FETCH_PATIENT_FAILURE,
} from "./patientTypes";
import api from "../../utils/Api";

export const fetchpatientRequest = () => {
  return {
    type: FETCH_PATIENT_REQUEST,
  };
};

export const fetchpatientSuccess = (patient) => {
  return {
    type: FETCH_PATIENT_SUCCESS,
    payload: patient,
  };
};

export const fetchpatientFailure = (error) => {
  return {
    type: FETCH_PATIENT_FAILURE,
    payload: error,
  };
};

export const fetchpatient = (patient_name) => {
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchpatientRequest);
    try {
      const response = await api.get(
        "relatedparty/patient/autocomplete?patient_name=" + patient_name,
        {
          headers: headers,
        }
      );

      const patient = response.data.data;
     // console.log("******* patient autocomplete - ", patient);
      dispatch(fetchpatientSuccess(patient));
    } catch (error) {
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchpatientFailure(errorMsg));
    }
  };
};
